import {Component, OnInit} from '@angular/core';
import {MessageService} from "../service/message.service";
import {QuestionnaireService} from "../service/questionnaire.service";
import {ReportData} from "../model/report-data";
import {QuestionnaireListItem} from "../model/questionnaire-list-item";

@Component({
  selector: 'app-questionnaire-report',
  templateUrl: './questionnaire-report.component.html',
  styleUrls: ['./questionnaire-report.component.css']
})
export class QuestionnaireReportComponent implements OnInit {
  Arr = Array;

  versionsList: QuestionnaireListItem[] = [];
  questionnaireId: string = null;

  reportData: ReportData = null;
  reportPeriod: number = 30;
  reportRange: number = 2;

  constructor(private questionnaireService: QuestionnaireService,
              private messageService: MessageService) {
  }

  ngOnInit() {
    this.questionnaireService.getVersions()
      .subscribe(value => {
        this.versionsList = value;
        this.questionnaireId = value != null && value.length > 0 ? value[0].id : null;
      }, this.onRejected());
  }

  buildReport() {
    this.reportData = null;
    this.questionnaireService.buildReport(this.questionnaireId, this.reportPeriod, this.reportRange)
      .then(value => {
        this.reportData = value;
        if (value.questions.length == 0) {
          alert("There is no data to display");
        }
      })
      .catch(this.onRejected());
  }

  getMaxAttemptsCount(combinations: { attempt_answers: string[]; users_count: number }[]): number {
    return combinations
      .map(value => value.attempt_answers.length)
      .reduce((previousValue, currentValue) => Math.max(previousValue, currentValue));
  }

  private onRejected() {
    return err => {
      this.messageService.addError('error occurred', err);
      console.log(err);
    }
  }

  onChangeReportPeriod(value: string) {
    if (value == null || value.length == 0) {
      this.reportPeriod = 0;
    }
  }


  onChangeReportRange(value: string) {
    if (value == null || value.length == 0) {
      this.reportRange = 0;
    }
  }
}



// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/questionnaire-report/questionnaire-report.component.ts